export default "__VITE_ASSET__bfca50e7__"